import { render, staticRenderFns } from "./CheckboxCustom.vue?vue&type=template&id=9f7fa216"
import script from "./CheckboxCustom.vue?vue&type=script&lang=js"
export * from "./CheckboxCustom.vue?vue&type=script&lang=js"
import style0 from "./CheckboxCustom.vue?vue&type=style&index=0&id=9f7fa216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports